import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiUrl } from '../constants/apiUrl';
import { NbsUser } from '../models/entities/nbs-user';
import { VNbsUser } from '../models/entities/v-nbs-user';
import { ListResponseModel } from '../models/responseModels/list-response-model';
import { ObjectResponseModel } from '../models/responseModels/object-response-model';
import { ResponseModel } from '../models/responseModels/response-model';

@Injectable({
  providedIn: 'root'
})
export class NbsUserService {

  constructor(private httpClient: HttpClient, private router: Router) { }

  getList(): Observable<ListResponseModel<VNbsUser>> {
    return this.httpClient.get<ListResponseModel<VNbsUser>>(ApiUrl.url + "NbsUser/getList");
  }

  loginControl(userName: string, password: string): Observable<ObjectResponseModel<NbsUser>> {
    return this.httpClient.get<ObjectResponseModel<NbsUser>>(ApiUrl.url + "NbsUser/loginControl?username=" + userName + "&password=" + password);
  }

  changePassword(id: number, oldPassword: string, newPassword: string): Observable<boolean> {
    return this.httpClient.get<boolean>(ApiUrl.url + "NbsUser/changePassword?Id=" + id + "&oldPassword=" + oldPassword + "&newPassword=" + newPassword);
  }

  getById(id: number): Observable<ObjectResponseModel<NbsUser>> {
    return this.httpClient.get<ObjectResponseModel<NbsUser>>(ApiUrl.url + "NbsUser/getById?id=" + id);
  }

  getListByRoleId(roleId: number): Observable<ListResponseModel<VNbsUser>> {
    return this.httpClient.get<ListResponseModel<VNbsUser>>(ApiUrl.url + "NbsUser/getListByRoleId?roleId=" + roleId);
  }

  add(nbsUser: NbsUser) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "NbsUser/add", nbsUser);
  }

  update(nbsUser: NbsUser) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "NbsUser/update", nbsUser);
  }

  delete(id: number) {
    return this.httpClient.post<ResponseModel>(ApiUrl.url + "NbsUser/delete?Id=" + id, "");
  }


  saveLoginUser(nbsUser: NbsUser) {
    sessionStorage.setItem('loginUserId', nbsUser.id.toString());
    sessionStorage.setItem('loginUserRoleId', nbsUser.roleId.toString());
    sessionStorage.setItem('loginUserName', nbsUser.fullName);
  }

  logout() {
    sessionStorage.clear();
    sessionStorage.removeItem('loginUserId');
    sessionStorage.removeItem('loginUserRoleId');
    sessionStorage.removeItem('loginUserName');
    this.router.navigateByUrl('login');
  }

  loggedIn(): boolean {
    if (parseInt(sessionStorage.getItem('loginUserId')) == 0 || sessionStorage.getItem('loginUserId') == null || sessionStorage.getItem('loginUserId') == "") return false;
    return true;
  }

  getUserId() {
    return parseInt(sessionStorage.getItem('loginUserId'));
  }

  getRoleId() {
    return parseInt(sessionStorage.getItem('loginUserRoleId'));
  }

  getLoginUserName(){
    return sessionStorage.getItem('loginUserName');
  }

}
